import { render, staticRenderFns } from "./ModalExpiredMembership.vue?vue&type=template&id=207d8d99&scoped=true&"
import script from "./ModalExpiredMembership.vue?vue&type=script&lang=js&"
export * from "./ModalExpiredMembership.vue?vue&type=script&lang=js&"
import style0 from "./ModalExpiredMembership.vue?vue&type=style&index=0&id=207d8d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d8d99",
  null
  
)

export default component.exports